import { Card } from "@vega-core/components/shadcn/card";
import { Skeleton } from "@vega-core/components/shadcn/skeleton";
import { EMPTY_CELL_VALUE } from "@vega-core/constants/global";
import { createUrlSlug } from "@vega-core/utils/url.helper";

import { getMetricDisplayValue } from "../../utils/dealTrackingMetricDisplay";
import { type ScalarInsightTrackingMetric } from "../../utils/metricGuards";

const LOADING_PLACEHOLDERS = Array.from({ length: 8 }, (_, index) => index);

type KpiMetricCardsProps = {
  metrics: ScalarInsightTrackingMetric[];
  isLoading?: boolean;
};

export const KpiMetricCards = ({ metrics, isLoading }: KpiMetricCardsProps) => {
  if (!isLoading && metrics.length === 0) return null;

  return (
    <div
      className="grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-4"
      data-testid="kpi-metric-cards"
    >
      {isLoading
        ? LOADING_PLACEHOLDERS.map((id) => (
            <Card
              className="flex flex-col gap-2 p-4 shadow-none"
              data-testid={`kpi-metric-loading-${id}`}
              key={id}
            >
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-6 w-1/2" />
            </Card>
          ))
        : metrics.map((metric) => (
            <Card
              className="flex flex-col gap-1 p-4 shadow-none"
              data-testid={`kpi-metric-${createUrlSlug(metric.label)}`}
              key={metric.label}
            >
              <p
                className="body-small-medium"
                data-testid={`kpi-metric-${createUrlSlug(metric.label)}-title`}
              >
                {metric.label}
              </p>
              <p
                className="body-large-regular text-text/secondary truncate"
                data-testid={`kpi-metric-${createUrlSlug(metric.label)}-value`}
              >
                {getMetricDisplayValue(metric) || EMPTY_CELL_VALUE}
              </p>
            </Card>
          ))}
    </div>
  );
};
